// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__NjMd5","footerContent":"footer_footerContent__pJf8q","splitLine":"footer_splitLine__POQJr"};